import React, { Component, PropTypes } from 'react';

class Verified extends Component {
  render() {
    let errorBox = '';
    if (this.props.isFailure) {
      errorBox = <div className="error">Conferma il Tinabalike in app</div>;
    }
    let messageText = ''
    if (this.props.rememberMe) {
      messageText = 'Ti verrà inoltrata una notifica in app, per poter ricordare al prossimo accesso i dati del tuo account. Accettando questa notifica potrai effettuare nuovi Tinabalike senza dover autenticarti.';
    } else {
      messageText = 'Ti verrà inoltrata una notifica in app, per poter confermare il Tinabalike. Accettando questa notifica potrai effettuare il trasferimento.'
    }
    console.log(this.props.profile);
    return (
      <main className="app-body">
        <div className="message-box">
          {errorBox}
          <p>{messageText}</p>
          <p><strong>Vuoi proseguire?</strong></p>
        </div>
        <div className="clearfix">
          <button className="light" onClick={(e) => { e.preventDefault(); this.props.resign(); }} style={{float: 'none !important', margin:'0 auto !important' }}> Annulla</button>
          <button onClick={(e) => { e.preventDefault(); this.props.onCheckClick(); }} style={{float: 'none !important', margin:'0 auto !important' }}> Prosegui</button>
        </div>
      </main>
    );
  }
}

Verified.propTypes = {
  onCheckClick: PropTypes.func.isRequired,
  resign: PropTypes.func.isRequired,
  isFailure: PropTypes.bool.isRequired
};

export default Verified;



/** WEBPACK FOOTER **
 ** ./src/components/Verified.jsx
 **/